(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const active = new Set();
  // Reveal fixed-size details once; never distort the hardware or capture scroll.
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(({target, isIntersecting}) => {
        if (!isIntersecting) return;
        observer.unobserve(target);
        if (reduced.matches || !target.animate) return;
        const animation = target.animate([
          {opacity:0, transform:'translate3d(0,12px,0)'},
          {opacity:1, transform:'translate3d(0,0,0)'}
        ], {duration:520, easing:'cubic-bezier(.2,.7,.3,1)'});
        active.add(animation);
        animation.finished.then(() => active.delete(animation), () => active.delete(animation));
      });
    }, {threshold:.15});
    document.querySelectorAll('.detail-card,.editorial-inset,.spec-data tr,.spec-chips>span').forEach(item => observer.observe(item));
  }
  reduced.addEventListener('change', () => {
    if (reduced.matches) active.forEach(animation => animation.cancel());
  });
})();
